
import { getVerificationCode, validateCode } from '../services/verification';
import { message } from '@vadp/ui';

export default{
  namespace: 'twoFactor',
  state: {
    ...initialState },
  effects: {
    * getCode({ payload }, { call, put }) {
      yield put({ type: 'updateBtnDisabled', payload: { btnDisabled: true } });
      const res = yield call(getVerificationCode);
      if (res) {
        if (res.code=== 200) {
          yield put({ type: 'updateBtnDisabled', payload: { btnDisabled: false } });
          message.success(res.result.message);
        } else  if(res.code === 401){
          message.error(res.message);
        }else{
          message.error("获取验证码失败！");
        }
      }
    },

    * validateCode({ payload }, { call, put }) {
      const { factorCode } = payload;
      const response = yield call(validateCode, payload : { factorCode: factorCode});
      if (response.code === 200) {
        localStorage.removeItem('BASICLAYOUT_REFRESH_KEY');
        localStorage.removeItem('REFRESH_CURRENT_MENU');
        localStorage.removeItem('BROWSER_IS_REFRESH');
        localStorage.removeItem('BROWSER_REFRESH_TIME');
        localStorage.removeItem('RESTORE_STATE');
        yield put({ type: 'updateStatus', payload: true });
        window.location.href = window.REACT_APP_CONFIG.contextPath.concat('/');
      } else {
        message.error(response.message);
      }
    },

  },
  reducers: {
    updateStatus(state, { payload }) {
      return { ...state, loginStatus: payload };
    },
    updateBtnDisabled(state, { payload }) {
      return { ...state, btnDisabled: payload.btnDisabled };
    },
    updateValidateBtnDisabled(state, { payload }) {
      return { ...state, validateBtnDisabled: payload.validateBtnDisabled };
    },
  },
};
const initialState = {
  btnDisabled: false,
  validateBtnDisabled: false,
};



// WEBPACK FOOTER //
// ./src/models/twoFactor.js